import React from 'react';
import { classes, st } from './MonthDropdown.st.css';
import setMonth from 'date-fns/setMonth';

import { DropdownPicker as DatePickerDropdown } from '../../DatePickerDropdown';
import { MonthDropdownProps, MonthOptions } from './MonthDropdown.types';

const optionsOf = (items: MonthOptions) =>
  items.map((item, index) => ({ value: item, id: index }));

const MonthDropdown = ({
  className,
  months,
  date,
  onChange,
  ariaLabel,
  ariaLabelledBy,
}: MonthDropdownProps) => {
  const options = optionsOf(months);
  const selectedMonth =
    options.find(({ id }) => id === date.getMonth()) ?? options[0];

  return (
    <DatePickerDropdown
      dataHook="datepicker-month-dropdown"
      className={st(classes.root, className)}
      caption={selectedMonth?.value}
      options={options}
      selectedId={selectedMonth.id}
      onChange={({ id }) => onChange(setMonth(date, id as number))}
      ariaLabel={ariaLabel}
      ariaLabelledBy={ariaLabelledBy}
    />
  );
};

export { MonthDropdown };
